/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';
import {dlsColor} from '../../theme/theme';
import {DLSTheme} from '../../types/types';

export interface SearchResultsCountType {
  searchedGroupData?: object;
  isGroupsFilter?: boolean;
  searchValue: string;
  searchedFilterData?: any[];
  paddingLeft?: string;
  tooMany?: boolean;
}

export const useStyles = makeStyles((theme: DLSTheme) => ({
  searchResultsText : {
    color                          : dlsColor('grey3'),
    padding                        : '0px 35px 15px 35px',
    letterSpacing                  : '1px',
    paddingLeft                    : ({paddingLeft}: {paddingLeft?: string}) => paddingLeft,
    [theme.breakpoints.down('sm')] : {
      padding : '0px 35px 15px 5px'
    },
    ...theme.dls?.typography?.tags
  }
}));

export const SearchResultsCount = ({
  searchedGroupData,
  isGroupsFilter = false,
  searchValue,
  searchedFilterData,
  paddingLeft = '',
  tooMany = false
}: SearchResultsCountType) => {
  const classes = useStyles({paddingLeft});
  return (
    <div className={classes.searchResultsText}>
      {!tooMany ? translate(
        Object.keys(searchedGroupData || {})?.length === 1 ||
      searchedFilterData?.length === 1 ? 'common:search.results' : 'common:search.results_plural',
        {
          count : isGroupsFilter
            ? Object.keys(searchedGroupData)?.length
            : searchedFilterData?.length,
          val           : `"${searchValue}"`,
          interpolation : {escapeValue: false}
        }
      ) : translate('common:search.tooManyResults')}
    </div>
  );
};

export default SearchResultsCount;
